"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.BeforeSaveTask = void 0;
var inversify_1 = require("inversify");
var event_tracking_core_1 = require("@al/event-tracking-core");
var types_1 = require("../types");
var utils_1 = require("../utils");
var processor_1 = require("../utils/processor");
var fields_1 = require("../constants/fields");
var BeforeSaveTask = /** @class */ (function () {
    function BeforeSaveTask() {
    }
    BeforeSaveTask.prototype.resolveCountryId = function (countryId) {
        var cnid = Number(countryId);
        return isNaN(cnid) ? 0 : cnid;
    };
    BeforeSaveTask.prototype.mayMaskingInputContent = function (data, needMasking) {
        var inputContentAbbr = (0, fields_1.getFieldKeyByValue)("inputContent") || "";
        var content = data.inputContent || data[inputContentAbbr];
        if (needMasking) {
            return (0, processor_1.contentMasking)(content);
        }
        return content;
    };
    BeforeSaveTask.prototype.transform = function (config, data, route) {
        var _a;
        var record = __assign(__assign({ uri: (route === null || route === void 0 ? void 0 : route.uri) || "", screenNum: (route === null || route === void 0 ? void 0 : route.screenNum) || 0, screenOrder: (route === null || route === void 0 ? void 0 : route.screenOrder) || 1, screenParam: (route === null || route === void 0 ? void 0 : route.screenParam) || {}, screenExtra: (route === null || route === void 0 ? void 0 : route.screenExtra) || {}, screenReferrerNum: (route === null || route === void 0 ? void 0 : route.screenReferrerNum) || -1, screenReferrer: (route === null || route === void 0 ? void 0 : route.screenReferrer) || "", screenReferrerOrder: (route === null || route === void 0 ? void 0 : route.screenReferrerOrder) || 0, isComplete: true }, data), { extraInfo: __assign(__assign(__assign({}, route === null || route === void 0 ? void 0 : route.extraInfo), ((data === null || data === void 0 ? void 0 : data.extraInfo) || (data === null || data === void 0 ? void 0 : data.ext))), { sm_device_id: config.smDeviceId || "" }), appId: (0, utils_1.resolveAppId)(), countryId: this.resolveCountryId(config.countryId), appBrand: config.appBrand || "", deviceId: config.deviceId || "", userId: config.userId || 0, adjustId: config.adjustId || "", googleAdId: config.googleAdId || "", deviceUuid: config.deviceUuid || "", sessionId: this.sessionService.get() || "", appVersion: config.appVersion || "", irn: 0, shouldDelete: false });
        var durationAbbr = (0, fields_1.getFieldKeyByValue)("duration") || "";
        var componentTypeAbbr = (0, fields_1.getFieldKeyByValue)("componentType") || "";
        var componentIdAbbr = (0, fields_1.getFieldKeyByValue)("componentId") || "";
        var controlNumAbbr = (0, fields_1.getFieldKeyByValue)("controlNum") || "";
        var businessClickTypeAbbr = (0, fields_1.getFieldKeyByValue)("businessClickType") || "";
        var businessInfoAbbr = (0, fields_1.getFieldKeyByValue)("businessInfo") || "";
        var listInfoAbbr = (0, fields_1.getFieldKeyByValue)("listInfo") || "";
        var exposeCountAbbr = (0, fields_1.getFieldKeyByValue)("exposeCount") || "";
        var elementInfoTypeAbbr = (0, fields_1.getFieldKeyByValue)("elementInfoType") || "";
        var elementInfoAbbr = (0, fields_1.getFieldKeyByValue)("elementInfo") || "";
        switch (data.eventType) {
            case types_1.EventType.View:
                record = __assign(__assign({}, record), { duration: data.duration || data[durationAbbr] || 0 });
                break;
            case types_1.EventType.Click:
                record = __assign(__assign({}, record), { componentType: data.componentType || data[componentTypeAbbr] || 0, componentId: data.componentId || data[componentIdAbbr] || "", controlNum: data.controlNum || data[controlNumAbbr] || 0, businessClickType: data.businessClickType || data[businessClickTypeAbbr] || 0, businessInfo: data.businessInfo || data[businessInfoAbbr] || {} });
                break;
            case types_1.EventType.Expose:
                record = __assign(__assign({}, record), { isComplete: true, listInfo: (data.listInfo || data[listInfoAbbr] || []).map(function (info) {
                        return __assign(__assign({}, info), { controlNum: info.controlNum || info[controlNumAbbr] || 0, duration: info.duration || info[durationAbbr] || 0, exposeCount: info.exposeCount || info[exposeCountAbbr] || 1, elementInfoType: info.elementInfoType || info[elementInfoTypeAbbr] || 0, elementExtraInfo: info.elementExtraInfo || info.ext || {}, elementInfo: info.elementInfo || info[elementInfoAbbr] || {} });
                    }) });
                break;
            case types_1.EventType.Input:
                record = __assign(__assign({}, record), { isComplete: false, controlNum: (data.data && (((_a = data.data) === null || _a === void 0 ? void 0 : _a.controlNum) || data.data[controlNumAbbr] || 0)) || 0 });
                break;
            case types_1.EventType.Statistics:
                record = __assign(__assign({}, record), { isComplete: data.isComplete || false });
                break;
            default:
                break;
        }
        return record;
    };
    BeforeSaveTask.prototype.execute = function (context) {
        return __awaiter(this, void 0, void 0, function () {
            var current, config, records;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.routeStackService.getCurrent()];
                    case 1:
                        current = _a.sent();
                        config = this.sdkConfigService.get();
                        context.list = context.list
                            .map(function (data) {
                            return _this.transform(config, data, current);
                        })
                            .filter(function (v) { return v; });
                        return [4 /*yield*/, this.logDataStore.queryAllRecords()];
                    case 2:
                        records = _a.sent();
                        context.list = context.list.map(function (item) {
                            if (item.eventType === types_1.EventType.Input) {
                                var data = item.data, needMasking = item.needMasking, rest = __rest(item, ["data", "needMasking"]);
                                var exists = records.find(function (r) { return r.inputKey === item.inputKey; });
                                if (exists && !exists.isComplete && exists.inputList) {
                                    exists.inputList.push(__assign(__assign({}, data), { inputContent: _this.mayMaskingInputContent(data, needMasking) || "" }));
                                    return exists;
                                }
                                return __assign(__assign({}, rest), { inputList: [
                                        __assign(__assign({}, data), { inputContent: _this.mayMaskingInputContent(data, needMasking) || "" }),
                                    ] });
                            }
                            return item;
                        });
                        return [2 /*return*/];
                }
            });
        });
    };
    __decorate([
        (0, inversify_1.inject)(event_tracking_core_1.TYPES.IConfigService),
        (0, inversify_1.named)(types_1.TAG.SDKConfigService),
        __metadata("design:type", Object)
    ], BeforeSaveTask.prototype, "sdkConfigService", void 0);
    __decorate([
        (0, inversify_1.inject)(event_tracking_core_1.TYPES.IRouteStackService),
        __metadata("design:type", Object)
    ], BeforeSaveTask.prototype, "routeStackService", void 0);
    __decorate([
        (0, inversify_1.inject)(types_1.TYPES.ILogDataStore),
        __metadata("design:type", Object)
    ], BeforeSaveTask.prototype, "logDataStore", void 0);
    __decorate([
        (0, inversify_1.inject)(event_tracking_core_1.TYPES.ISessionService),
        __metadata("design:type", Object)
    ], BeforeSaveTask.prototype, "sessionService", void 0);
    BeforeSaveTask = __decorate([
        (0, inversify_1.injectable)()
    ], BeforeSaveTask);
    return BeforeSaveTask;
}());
exports.BeforeSaveTask = BeforeSaveTask;
